import Cookies from 'js-cookie';

// Token 操作方法
export function getToken(name) {
  return Cookies.get(name);
}

export function setToken(name, value) {
  return Cookies.set(name, value);
}

export function removeToken(name) {
  return Cookies.remove(name);
}

// LocalStorage 操作方法
export function setLocalStorage(name, value) {
  return localStorage.setItem(name, value);
}

export function getLocalStorage(name) {
  return localStorage.getItem(name);
}

export function removeLocalStorage(name) {
  return localStorage.removeItem(name);
}
